<template>
  <div class="text-left">
    <v-card>
      <v-form class="pa-6" ref="form" lazy-validation>
        <row-col-select-one-field
          v-model="stay.person"
          data-source="person"
          :label="$t('form.person_stay')"
          :required="true"
        />

        <v-row>
          <col-date-field
            v-model="stay.start_date"
            :label="$t('form.date_start')"
          />
          <col-date-field 
            v-model="stay.end_date"
            :label="$t('form.date_end')"
          />
        </v-row>

        <row-col-radio-horizontal-field
          v-model="stay.type"
          :label="$t('form.stay_type')"
          :options="[
            { text: $t('form.stay_predoc'), value: 'predoc' },
            { text: $t('form.stay_posdoc'), value: 'posdoc' },
            { text: $t('form.stay_other'), value: 'other' }
          ]"
          :required="true"
        />

        <row-col-select-one-field
          v-model="stay.organization"
          data-source="organization"
          :label="$t('form.organization_stay')"
          :required="true"
          :allow-custom-value="true"
        />

        <row-col-text-field
          v-model="stay.responsible"
          :label="$t('form.responsible')"
          :rules="rules.char_max_250"
        />

        <row-col-text-area-field
          v-model="stay.description"
          :label="$t('form.description_stay')"
          :rules="rules.char_max_2000"
        />

        <row-col-select-one-field
          v-model="stay.funder_program"
          data-source="funder_program"
          :label="$t('form.funder_program_stay')"
        />

        <row-col-text-area-field
          v-model="stay.funding_comments"
          :label="$t('form.funding_comments')"
          :rules="rules.char_required_max_2000"
        />
         
        <v-divider />
        <div class="text-center">
          <v-btn text @click="$router.back()"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
          <v-btn color="primary" @click="save" class="ml-2"><v-icon left>mdi-content-save</v-icon>{{ $t("button.save") }}</v-btn>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import validationRules from "../../mixins/validationRules";
import stay_model from "@/mixins/model_utils/stay_model";
import RowColTextAreaField from "@/components/reusables/RowColTextAreaField.vue";
import ColDateField from "@/components/reusables/ColDateField.vue";
import RowColSelectOneField from "@/components/reusables/RowColSelectOneField.vue";
import RowColTextField from "@/components/reusables/RowColTextField.vue";
import RowColRadioHorizontalField from "@/components/reusables/RowColRadioHorizontalField.vue";

export default {
  components: {
    ColDateField,
    RowColTextAreaField,
    RowColSelectOneField,
    RowColTextField,
    RowColRadioHorizontalField
  },
  mixins: [validationRules, stay_model],
  name: "EditStayDetail",
  data: () => ({
    stay: {
      person: null,
      organization: null,
      responsible: null,
      type: null,
      funder_program: null,
      start_date: null,
      end_date: null,
      description: null,
      funding_comments: null
    }
  }),

  created() {
    console.log(this.$route.params.id);
    if (this.$route.params.id > -1) {
      this.getStay();
    }
  },

  computed: {
    processData() {
      let data = { ...this.stay };
      return data;
    }
  },

  methods: {
    getStay() {
      let path =
        this.$store.state.endpoint + "/stay/" + this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.stay = response.data;
          console.log(this.stay);
        })
        .catch(error => {
          console.log("got error");
          console.log(error);
        });
    },

    save() {
      if (this.$refs.form.validate()) {
        let path;
        if (this.$route.params.id > -1) {
          path =
            this.$store.state.endpoint +
            "/stay/" +
            this.$route.params.id;
          console.log(this.processData);
          axios
            .patch(path, this.processData)
            .then(() => {
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.updateItem")
              });
              this.$router.push("/manage/edit/stays");
            })
            .catch(error => {
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        } else {
          console.log("creating new stay");
          path = this.$store.state.endpoint + "/stay";
          axios
            .post(path, this.processData)
            .then(response => {
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.createItem")
              });
              this.$router.push("/manage/edit/stays");
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        }
      }
    }
  }
};
</script>
